import React from "react";
import { getStreakColor } from "./../../../helper/xpHelpers.js";

/**
 * StreakWidget — chama de fogo com numero de dias consecutivos.
 * Props: currentStreak, longestStreak, compact
 */
class StreakWidget extends React.Component {
  render() {
    var current = this.props.currentStreak || 0;
    var longest = this.props.longestStreak || 0;
    var color = getStreakColor(current);
    var compact = this.props.compact;

    return (
      <div className={compact ? 'p-2' : 'p-3 text-center'} style={{
        background: '#fff',
        borderRadius: '10px',
        border: '1px solid #eee',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
      }}>
        <div style={{
          display: compact ? 'flex' : 'block',
          alignItems: 'center',
          gap: '10px'
        }}>
          <div style={{
            width: compact ? '40px' : '60px',
            height: compact ? '40px' : '60px',
            background: 'linear-gradient(135deg, ' + color + ' 0%, #FFC107 100%)',
            borderRadius: '50%',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontSize: compact ? '1.1rem' : '1.6rem',
            boxShadow: '0 2px 8px ' + color + '60',
            margin: compact ? 0 : '0 auto 8px'
          }}>
            <i className="fas fa-fire" />
          </div>
          <div style={{ textAlign: compact ? 'left' : 'center', flex: 1 }}>
            <h4 className="mb-0" style={{ color: color, fontWeight: 700, fontSize: compact ? '1.1rem' : '1.5rem' }}>
              {current} {compact && current === 1 ? 'dia' : 'dias'}
            </h4>
            <small className="text-muted" style={{ fontSize: '0.7rem' }}>
              {current > 0 ? 'streak ativo' : 'comece um streak hoje'}
            </small>
            {!compact && longest > current && (
              <div className="mt-1">
                <small className="text-muted">
                  <i className="fas fa-trophy mr-1" style={{ color: '#FFD700' }} />
                  Recorde: <strong>{longest}</strong> dias
                </small>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default StreakWidget;
